import { rankMixin } from "@mixin/rank";
export default {
  name: "cityPageRank",
  mixins: [rankMixin],
  methods: {}
};